import { render } from "./MedicalCard.vue?vue&type=template&id=a5cae0aa"
import script from "./MedicalCard.vue?vue&type=script&lang=js"
export * from "./MedicalCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__